import { FileService } from '@services/file.service';
import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { IFileModel } from '@models/Common';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

// 1 = carregar ficheiro, 2 = apenas selecionar ficheiro
export enum ENUMTypeDocument {
    Load = 1,
    Select = 2,
    Merchant = 3
}

export enum ENUMTypeDocumentVerification {
    Merchant = 1,
    Consumer = 2,
    HouseHolders = 3,
    Saft = 4
}
@Component({
    selector: 'app-select-file-upload',
    templateUrl: './select-file-upload.component.html',
    styleUrls: ['./select-file-upload.component.scss'],
})
export class SelectFileUploadModalComponent implements OnInit {

    private onChange: Function;
    private onUpload: Function;

    public File: IFileModel;
    public FileTemplate: string;
    public Modules: { Id: number, Name: string }[] = [];

    public SelectedModule: { Id: number, Name: string } = null;

    public FileFormatsAllowed: string = '.xlsx';
    public Title: string = '';

    public Type: ENUMTypeDocument = ENUMTypeDocument.Load;

    public ENUMTypeDocument = ENUMTypeDocument;

    public ViewDocument: boolean = false;

    public ExcelData: any[][] = [];
    public XMLData: any = null;
    public RootKey: string = ''; // ← preenchido dinamicamente após parse

    public Errors: string;

    public TypeDocumentVerification: ENUMTypeDocumentVerification;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController,
        private FileService: FileService
    ) {

        this.Title = this.NavParams?.get('title') || null;
        this.onChange = this.NavParams?.get('onChange') || null;
        this.onUpload = this.NavParams?.get('onUpload') || null;
        this.FileTemplate = this.NavParams?.get('fileTemplate') || '';
        this.Type = this.NavParams?.get('type') || this.Type;
        this.TypeDocumentVerification = this.NavParams?.get('typeVerification') || this.TypeDocumentVerification;
        this.ViewDocument = this.NavParams?.get('viewDocument') || this.ViewDocument;
        this.Modules = this.NavParams?.get('modules') || [];

        this.FileFormatsAllowed = this.NavParams?.get('formatsAllowed') || '.xlsx';

        console.log(this.Modules);

        if (this.Modules?.length == 1)
            this.SelectedModule = this.Modules[0];

    }

    ngOnInit() { }

    /**
     * 
     * @param file 
     * @returns 
     */
    async OnChangeFile(file: any) {

        console.log(file);

        if (file?.files?.length == 0) return;

        if (this.onChange)
            this.File = await this.onChange(file);

        this.XMLData = null;
        this.ExcelData = [];

        if (this.File && this.ViewDocument) {

            if (this.FileFormatsAllowed?.includes('xlsx')) {
                this.ExcelData = await this.FileService.ReadExcelFile(file?.files[0]);

                if (this.ExcelData?.length > 2) {

                    let errors;

                    switch (this.TypeDocumentVerification) {
                        case ENUMTypeDocumentVerification.Merchant:

                            errors = this.FileService.ValidateStructureForMerchantFile(this.ExcelData);

                            console.log(errors);

                            break;
                        case ENUMTypeDocumentVerification.Consumer:

                            errors = this.FileService.ValidateStructureForConsumerFile(this.ExcelData);

                            console.log(errors);

                            break;

                        default:
                            break;
                    }

                    if (errors?.isValid === false) {
                        this.ExcelData = [];
                        this.Errors = "O ficheiro não é válido, utilize a estrutura do \"ficheiro template\".";
                        this.File = null;
                        return
                    }

                }
            }
            else if (this.FileFormatsAllowed?.includes('xml')) {

                const data = await this.FileService.ReadXMLFile(file?.files[0]);

                debugger
                const keys = Object.keys(data);
                this.RootKey = keys.length > 0 ? keys[0] : 'Desconhecido';
                this.XMLData = data; //[this.RootKey]; // ou data, dependendo do que quer exibir

            }
            else {

            }

        }

    }

    /**
     * 
     */
    async OnUploadFile() {

        console.log(this.SelectedModule);


        if (this.onChange) {
            const response = await this.onUpload(this.File, this.SelectedModule?.Id);

            if (response)
                this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);

        }
    }

    ChangeModule(e) {
        console.log(e);
        this.SelectedModule = e?.detail?.value || null;
    }

    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }


    GetDataRows(): any[][] {
        // slice(1) remove a primeira linha (headers)
        return this.ExcelData.slice(1);
    }
}
